exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-tenant-tsx": () => import("./../../../src/templates/tenant.tsx" /* webpackChunkName: "component---src-templates-tenant-tsx" */)
}

